module.exports = __webpack_public_path__ + "static/media/networking.964a48aa.jpg";